import {Col, Container, Row} from 'react-bootstrap';
import AppModal from '../AppModal';
import {Button, SearchBox} from '../../common';
import Icon from '../../../assets/icons';
import {useAuthContext, useLanguageContext, useThemeContext} from '../../../context';
import {formatNum} from '../../../constants';
import {useNavigate} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import useShortcut from '../../../hooks/useShortcut';
import OrderCompletionReceipt from '../OrderCompletionReceipt/index';
import {useReactToPrint} from 'react-to-print';

const TransactionSuccessfulModal = ({toggle, setToggle, order, orderLines, givenPosDiscount, tax, isRestaurantPos, activeOrders}) => {
    let navigate = useNavigate();

    const {theme} = useThemeContext();
    const {handleCreateOrder, business} = useAuthContext();
    const {I18n} = useLanguageContext();
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const [phone, setPhone] = useState('');
    const [orderReceiptData, setOrderReceiptData] = useState({});

    // const handlePrint = () => {
    //   // handlePrint
    // };

    const handleNewOrder = async () => {
        if (!isRestaurantPos) {
            if (activeOrders.length === 1) {
                await handleCreateOrder();
            }
        }

        await order.updateOrderStatus('complete');
        if (isRestaurantPos) {
            if (toggle) {
                console.log('NAVIGATE TO  POS COCKPIT');
                navigate('/pos-cockpit');
            }
        } else {
            if (toggle) {
                navigate('/pos');
            }
        }
    };

    useShortcut({
        keys: [{key: 'shift+n', action: handleNewOrder}],
    });

    const onChange = (label, val) => setPhone(val);

    const handleClose = event => {
        setToggle(false);
    };

    const prepareReceiptData = async () => {
        const account = await business.account.fetch();
        const customerData = await order?.customer.fetch();

        const orderReceipt = {
            account,
            business,
            order,
            orderLines,
            customerData,
            givenPosDiscount,
            tax,
        };
        setOrderReceiptData(orderReceipt);
    };

    useEffect(() => {
        prepareReceiptData();
    }, [order, givenPosDiscount, tax]);

    return (
        <AppModal className="transactionSuccessfulModal" toggle={toggle} handleClose={handleClose} title={I18n.pos_discounts}>
            <div style={{display: 'none'}}>
                <OrderCompletionReceipt ref={componentRef} orderReceiptData={orderReceiptData} />
            </div>
            <section className="transactionScreenMain" style={{background: theme.blackBg}}>
                <Container>
                    <Row className="justify-content-md-center">
                        <Col md={5}>
                            <div className="transactionScreenInner">
                                <div className="transactionPrintBox">
                                    <Icon name="oscarlogo2" fill={'white'} width={'53'} height={'50'} viewBox={'0 0 53 50'} />
                                    <p className="fontSize16  fontWeight500 marBot0" style={{color: theme.white}} onClick={handlePrint}>
                                        <span>
                                            <Icon name="printerNewIcon" fill={'white'} width={'24'} height={'24'} viewBox={'0 0 18 18'} />
                                        </span>
                                        <span> {I18n.print_receipt}</span>
                                    </p>
                                </div>
                                <div className="transactionIconBox">
                                    <p className="fontSize32 fontWeight500 textCenter marTop15" style={{color: theme.white}}>
                                        {I18n.transaction_successful}
                                    </p>

                                    <div className="card marTop60">
                                        <div className="iconBox">
                                            <Icon name="tickfilled" fill={theme.white} width="110" height="130" viewBox={'0 0 120 120'} />
                                        </div>
                                        <div className="amountbox">
                                            <p className="fontSize24 marBot0 fontWeigh400 textCenter" style={{color: theme.blackFont}}>
                                                <span>{I18n.amount_paid_via} </span>
                                                <span>{toggle?.method}: </span>
                                                <span>Rs.</span>
                                                <span>{formatNum(toggle?.total || 0)}</span>
                                            </p>
                                            <p className="fontSize48 marBot0 textCenter fontWeight700" style={{color: theme.blackFont}}>
                                                {I18n.change}: Rs.{formatNum(toggle?.change || 0)}
                                            </p>
                                        </div>

                                        <div className="receiptBox">
                                            <SearchBox type="pos" placeholder={I18n.for_receipt} onlyNumbers={true} value={phone} onChange={onChange} />
                                            <Button
                                                title={I18n.send}
                                                className={`width40 fontWeight600 fontSize18`}
                                                backgroundColor={theme.barclaysBlue}
                                                txtColor={theme.white}
                                                handleClick={handleNewOrder}
                                            />
                                        </div>
                                    </div>
                                    <div className="transactionBottomBox">
                                        <Button
                                            title={I18n.new_order}
                                            className={`width80 fontWeight400 fontSize24`}
                                            backgroundColor={theme.brightGreen}
                                            txtColor={theme.white}
                                            handleClick={handleNewOrder}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </AppModal>
    );
};

export default TransactionSuccessfulModal;
